import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setMessageBar, setOnBoardingComplete, setShowMenu, setShowSideMenu } from '../../../reduxStore/actions/flowActions';
import { setIsOnboarding, setOnBoardingModalsVisibility, setOnBoardingVisible } from '../../../reduxStore/actions/modalsActions';
import BasicCompanyInformation from './BasicCompanyInformation';
import Intro from './Intro';
import cls from './OnBoardingModals.module.scss';
import CreateDepartments from './CreateDepartments';
import AddNewPositionModal from './AddNewPositionModal';
import OnboardingOrgChart from './OnboardingOrgChart';
import { getAllComponentBlueprints, getFieldTypes } from '../../../services/components.service';
import { APP_NAME, CLEAR_TO_SET_DATA, WHAT_ARE_WORKFLOWS } from '../../../shared/utility';
import { first, take } from 'rxjs';
import { startTrial } from '../../../services/payments.service';
import { useEffect, useState } from 'react';

const OnboardingModals = props => {
	const navigate = useNavigate();
	const dispatch = useDispatch();

	const { onClose } = props;

	const { onBoardingModalsVisibility, isOnboarding } = useSelector(store => store.modalsReducer);
	const { authenticatedUser } = useSelector(store => store.authReducer);

	const [skipped, setSkipped] = useState(false);
	const [loading, setLoading] = useState(false);

	const {
		firstModalVisible,
		secondModalVisible,
		thirdModalVisible,
		fourthModalVisible,
		fifthModalVisible,
		positionModalVisible,
		
	} = onBoardingModalsVisibility;

	useEffect(() => {
		dispatch(setShowSideMenu(false));
		dispatch(setShowMenu(false));
	}, [onBoardingModalsVisibility, isOnboarding]);

	const toggleFirstModal = () => {
		dispatch(setOnBoardingModalsVisibility({ firstModalVisible: true }));
	};
	const toggleSecondModal = () => {
		dispatch(setOnBoardingModalsVisibility({ secondModalVisible: true }));
	};
	const toggleThirdModal = () => {
		dispatch(setOnBoardingModalsVisibility({ thirdModalVisible: true }));
	};
	const toggleFourthModal = () => {
		dispatch(setOnBoardingModalsVisibility({ fourthModalVisible: true }));
	};

	const toggleFifthModal = () => {
		dispatch(setOnBoardingModalsVisibility({ fifthModalVisible: true }));
	};
	const toggleSixthModal = () => {
		dispatch(setOnBoardingModalsVisibility({ sixthModalVisible: true }));
	};
	
	const toggleTwelvthModal = () => {
		dispatch(setOnBoardingModalsVisibility({ twelvthModalVisible: true }));
	};
	
	const toggleNoModal = () => {
		dispatch(setOnBoardingModalsVisibility({}));
	};
	const onCancel = () => {
		onClose();
	};

	return (
		<div>
			{firstModalVisible && (
				<Intro
					title={`1. Welcome to ${APP_NAME}, ${authenticatedUser?.first_name} ${authenticatedUser?.last_name}`}
					subtitle={''}
					video={WHAT_ARE_WORKFLOWS}
					checkbox={
						<>
							{`By using ${APP_NAME}, you agree with our `}
							<a href={`https://www.flowhero.app/${APP_NAME}/privacy-policy`}>Terms and Conditions</a> and <a href={`https://www.flowhero.app/${APP_NAME}/privacy-policy`}>Privacy Policy</a>
						</>
					}
					modalVisible={firstModalVisible}
					shadowedContainerStyle={{ width: '100%', height: '100%' }}
					modalWrapperStyle={{ width: '100%', height: '100%' }}
					childrenWrapperStyle={{}}
					onContinueButtonAction={toggleSecondModal}
					onCancel={() => { }}
				/>
			)}
			{secondModalVisible && (
				<BasicCompanyInformation modalVisible={secondModalVisible} shadowedContainerStyle={{ width: '100%', height: 'auto', minHeight: '100%' }} onPreviousButtonAction={toggleFirstModal} onContinueButtonAction={toggleThirdModal} onNextButtonAction={toggleThirdModal} />
			)}

			{thirdModalVisible && (
				<CreateDepartments
					hasTutorial
					modalVisible={thirdModalVisible}
					hasCloseButton={!isOnboarding}
					modalWrapperStyle={{}}
					shadowedContainerStyle={{ width: '100%', height: '100%' }}
					childrenWrapperStyle={{}}
					onPreviousButtonAction={toggleSecondModal}
					onContinueButtonClick={toggleFourthModal}
				/>
			)}
			{fourthModalVisible && (
				<OnboardingOrgChart
					hasTutorial
					modalVisible={fourthModalVisible}
					closeButtonAction={onCancel}
					modalWrapperStyle={{ width: '100%', height: '100%' }}
					shadowedContainerStyle={{ margin: '20% 10% 20% 10%', minWidth: '1110px', minHeight: '725px', maxHeight: '90vh' }}
					childrenWrapperStyle={{ margin: '0 2% 0 10%', minHeight: '725px', maxHeight: '90%' }}
					onCancel={() => {
						toggleNoModal();
					}}
					onPreviousButtonAction={toggleThirdModal}
					onContinueButtonPressed={() => {
						dispatch(setMessageBar({ show: false, message: '' }));
						startTrial()
							.pipe(take(1))
							.subscribe({});
						setSkipped(true);
						toggleFifthModal();
					}}
				/>
			)}
			{fifthModalVisible && (
				<Intro
					title={`You have now completed the company setup for ${APP_NAME}.`}
					modalVisible={fifthModalVisible}
					shadowedContainerStyle={{ width: '56%', height: '60%' }}
					modalWrapperStyle={{ width: '100%', height: '100%' }}
					loading={loading}
					childrenWrapperStyle={{}}
					onContinueButtonAction={() => {
						dispatch(setMessageBar({ show: false, message: '' }));
						getAllComponentBlueprints(CLEAR_TO_SET_DATA)
							.pipe(first())
							.subscribe({
								complete: () => getFieldTypes()
									.pipe(take(1))
									.subscribe({})
							});

						dispatch(setOnBoardingVisible(false));
						dispatch(setOnBoardingComplete(true));
						dispatch(setIsOnboarding(false));
						toggleFirstModal();
						navigate('/dashboard');
					}}
					onCancel={() => { }}
				>
					<div className={cls.subheadingContainer_III} style={{ flexDirection: 'column' }}>
						<p>{`Thank you for choosing ${APP_NAME} and hoping we will have a successful partnership and relationship`}</p>
						<br />
						<p>
							{skipped
								? `You can create your first workflow by looking for New Workflow in the next section. You can also use the predefined workflows available.`
								: `Please find time to review the workflow, components, steps and module you have created (if not skipped). Look for this workflow in the Workflow menu. To edit steps, click the box of target step you wish to edit. \
							To edit components and modules, buttons are available on the upper right side. At this point the module should be available to the admin only. You can click the Workflow button, and look for 'Show workflow to positions' \
							and select your target positions that you want this module and workflow available`}
						</p>
						<p>
							{skipped
								? `For now it will be better for you to create a blank workflow. For your first workflow we will create the Create Customer workflow. We will guide you on this. Click Continue to begin.`
								: `You may click Close and Dashboard to navigate the rest of ${APP_NAME}. Your module should be visible on the left side menus. You can return to this screen anytime by clicking Workflow on the upper right menus.`}
						</p>


					</div>
				</Intro>
			)}
			
			{positionModalVisible && (
				<AddNewPositionModal
					hasTutorial
					modalVisible={positionModalVisible}
					backButtonAction={toggleThirdModal}
					shadowedContainerStyle={{ width: '100%', height: '100%' }}
					modalWrapperStyle={{ width: '100%', height: '100%', overflow: undefined }}
					childrenWrapperStyle={{ margin: '0 2% 0 10%' }}
					previewOrgChartClick={toggleTwelvthModal}
					onContinueButtonAction={toggleFourthModal}
					onCancel={onCancel}
				/>
			)}
		</div>
	);
};

export default OnboardingModals;
